export default "__VITE_ASSET__B36IJsIA__"